module.exports = __webpack_public_path__ + "static/img/sc_07.756cf8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sc_07.jpg
// module id = 0Gc1
// module chunks = 33